import { useSelector } from 'react-redux'
import { Outlines, shaderMaterial } from '@react-three/drei'
import { extend, useFrame, useThree } from '@react-three/fiber'

import MeshSound from '../MeshSound'

import vertexShader from '@/webgl/shaders/screen/vertex.glsl?raw'
import fragmentShader from '@/webgl/shaders/screen/fragment.glsl?raw'

const ScreenShaderMaterial = shaderMaterial(
  {
    uTime: 0,
  },
  vertexShader,
  fragmentShader,
)

extend({ ScreenShaderMaterial })

export default function Television({ ...props }) {
  const { currentIndex } = useSelector((state) => state.progress)
  const { clock } = useThree()

  const screenMaterial = new ScreenShaderMaterial()

  useFrame(() => {
    screenMaterial.uniforms.uTime.value = clock.elapsedTime
  })

  return (
    <group
      onClick={props.onClick}
      onPointerEnter={props.onPointerEnter}
      onPointerLeave={props.onPointerLeave}
    >
      <mesh
        name="screen"
        geometry={props.nodes.screen.geometry}
        material={
          currentIndex === props.index ? screenMaterial : props.material
        }
        position={[-0.165, 2.213, -4.825]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.938}
      />
      <mesh
        name="TV"
        geometry={props.nodes.TV.geometry}
        material={props.material}
        position={[-0.145, 1.963, -4.915]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.938}
      >
        <Outlines
          thickness={props.outline && currentIndex === props.index ? 0.003 : 0}
          color="white"
        />
        <MeshSound index={props.index} />
      </mesh>
    </group>
  )
}
